import { inject, Pipe, PipeTransform } from '@angular/core';
import { MomentService } from '../services/moment.service';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {
  momentService = inject(MomentService);
  transform(dateString:string|Date|undefined, format:string = "dddd D [de] MMMM [del] YYYY"): string {
    if (!dateString) return '';
    
    const localDate:moment.Moment = this.momentService.moment.utc(dateString).local();
    const formated:string = localDate.format(format);

    return formated.charAt(0).toUpperCase() + formated.slice(1);
  }

}